import { render } from "./gf-checkbox.vue?vue&type=template&id=a4969d8a"
import script from "./gf-checkbox.vue?vue&type=script&lang=js"
export * from "./gf-checkbox.vue?vue&type=script&lang=js"

import "./gf-checkbox.vue?vue&type=style&index=0&id=a4969d8a&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__